import React from 'react';
import { useNavigate } from 'react-router-dom';

const services = [
  {
    id: 1,
    title: 'Pelayanan Rawat Jalan Berbasis Jamu',
    description: 'Layanan pengobatan dengan pendekatan jamu tradisional',
    icon: '🏥',
    href: 'Pelayanan Rawat Jalan Berbasis Jamu',
  },
  {
    id: 2,
    title: 'Griya Jamu',
    description: 'Pusat pembelajaran dan pengembangan jamu',
    icon: '🌿',
    href: 'Griya Jamu',
  },
  {
    id: 3,
    title: 'Laboratorium Klinik',
    description: 'Fasilitas pengujian dan penelitian klinis',
    icon: '🔬',
    href: 'Laboratorium Klinik',
  },
  {
    id: 4,
    title: 'Akupuntur & Akupresure',
    description: 'Terapi pengobatan tradisional',
    icon: '💆',
    href: 'Akupuntur & Akupresure',
  },
  {
    id: 5,
    title: 'Konsultasi Gizi',
    description: 'Layanan konsultasi nutrisi dan diet',
    icon: '🥗',
    href: 'Konsultasi Gizi',
  },
  {
    id: 6,
    title: 'Wisata Edukasi Tanaman Obat',
    description: 'Program wisata edukasi berbasis tanaman obat',
    icon: '🌺',
    href: 'Wisata Edukasi Tanaman Obat',
  },
  {
    id: 7,
    title: 'Pelatihan & Workshop Pemanfaatan Tanaman Obat',
    description: 'Program pelatihan pengolahan tanaman obat',
    icon: '👨‍🏫',
    href: 'Pelatihan & Workshop Pemanfaatan Tanaman Obat',
  },
  {
    id: 8,
    title: 'Produk & Layanan Bahan Baku Tanaman Obat',
    description: 'Penyediaan bahan baku tanaman obat berkualitas',
    icon: '🌾',
    href: 'produk-layanan',
  },
];

const ServiceGrid = () => {
  const navigate = useNavigate();

  const handleServiceClick = (service: typeof services[0]) => {
    navigate(`/layanan/${service.href}`, {
      state: { serviceData: service },
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {services.map((service) => (
        <div
          key={service.id}
          onClick={() => handleServiceClick(service)}
          className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
        >
          <div className="flex items-start gap-4">
            <span className="text-4xl">{service.icon}</span>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600">{service.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceGrid;
